import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';

import {
  COLUMN_WIDTH_ACTIONS,
  COLUMN_WIDTH_DRAFT_TITLE,
  COLUMN_WIDTH_STATUS,
} from 'src/constants/table';
import { PostType } from 'src/graphql/__generated__';
import type { DraftJob } from 'src/types';

import { DraftJobActions } from '../JobActions/DraftJobActions/DraftJobActions';
import { JobStatus } from '../JobStatus/JobStatus';
import { JobTitleAndLocation } from '../JobTitleAndLocation/JobTitleAndLocation';
import { Table, TableCell, TableHeaderCell } from '../Table';

import translations from './.vocab';

interface Props {
  draftJobs: DraftJob[];
  loading?: boolean;
}

export const DraftListDesktopAndTablet = ({
  draftJobs,
  loading = false,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Table>
      <Box component="thead">
        <tr>
          <TableHeaderCell paddingLeft="medium">{t('Status')}</TableHeaderCell>
          <TableHeaderCell>{t('Job')}</TableHeaderCell>
          <TableHeaderCell paddingRight="medium" align="right">
            {t('Draft Actions')}
          </TableHeaderCell>
        </tr>
      </Box>

      <Box component="tbody">
        {draftJobs.map((draft) => (
          <tr key={draft.draftId}>
            <TableCell
              width={COLUMN_WIDTH_STATUS}
              minWidth={COLUMN_WIDTH_STATUS}
              maxWidth={COLUMN_WIDTH_STATUS}
              paddingLeft="medium"
            >
              <JobStatus
                isDraft={true}
                loading={loading}
                status={draft.status}
              />
            </TableCell>

            <TableCell maxWidth={COLUMN_WIDTH_DRAFT_TITLE}>
              <JobTitleAndLocation
                id={draft.draftId}
                isDraft={true}
                advertiserReference={draft.advertiserReference}
                createdDate={draft.createdDate}
                createdBy={draft.createdBy}
                title={draft.title}
                location={draft.location}
                loading={loading}
                postType={PostType.DIRECT}
              />
            </TableCell>

            <TableCell
              width={COLUMN_WIDTH_ACTIONS}
              minWidth={COLUMN_WIDTH_ACTIONS}
              maxWidth={COLUMN_WIDTH_ACTIONS}
              paddingRight="medium"
            >
              <Box display="flex" justifyContent="flexEnd" alignItems="center">
                <DraftJobActions loading={loading} draftId={draft.draftId} />
              </Box>
            </TableCell>
          </tr>
        ))}
      </Box>
    </Table>
  );
};
